
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import MediaCard from 'common/designer-modules/modules/media';
import { MediaTitile } from 'common/designer-modules/modules/media/modules';
import MMSPageMediaWraper from 'common/designer-modules/modules/media-horizontal-wraper';
import Button from 'common/components/elements/buttons/primary';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';
import { getMediaIndividualPagePath } from 'common/designer-modules/siteDesigner';
import { generateMapingIdForUrl } from 'common/designer-modules/siteDesigner';

import Link from 'common/components/modules/link';


const ContentShowcase = ({
   settings,
   type,
   data,
   isMobile,
   isFetching,
   globalSettings,
   onNextContent,
   isNextFetching,
   contentShowcaseRef,
   getTheHref,
   isNextApp,
   sitePages,
}) => {
   const linkToPage = useRef(null)
   const { getModifySectionGlobalSetting } = useSiteGlobalSettingsHelper(globalSettings);
   const contentCardSettings = getModifySectionGlobalSetting('content_cards');
   const {
      title,
      description,
      alignment,
      content_card_size,
      link_button_text,
      link_to,
   } = settings
   useEffect(() => {
      if(link_to && !linkToPage?.current){
         const page = sitePages.find(page => page.content_mapping_id.toString() === link_to.toString());
         linkToPage.current = page;
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const cardPropsProps = {
      type: type,
      cardSize: content_card_size,
      contentCardSettings: contentCardSettings,
      isNextApp: isNextApp,
   }
   const list = data?.data || [];
   return (
      <div
         ref={ contentShowcaseRef }
         className='flex flex-col gap-6 w-full'>
         <div className='flex justify-between px-6'>
            <MediaTitile
               title={ title }
               isMobile={ isMobile }
               total={ data?.total }
               type={ type }
               description={ description }
               alignment={ alignment }
               showContentCount
            />
            {
               link_to && (
                  <Link href={ getMediaIndividualPagePath(getTheHref, { content_mapping_id: generateMapingIdForUrl(link_to), name: linkToPage?.current?.name || '' }) } isNextApp prefetch>
                     <div className='h-9 '>
                        <Button
                           classNames='h-full'
                           text={ link_button_text }
                           iconName='arrow-right'
                           padding='0 py-[2] px-[14px]'
                           textMarginX='0'
                           textClassName='mr-2'
                           // fontWeight='semibold'
                           borderRadius='label'
                           backgroundColor='transparent'
                           textColor='secondary dark:text-secondary-dark'
                           textSize='small'
                           fontIconColor='secondary'
                           darkIconColor='secondary-dark'
                        />
                     </div>
                  </Link>
               )
            }

         </div>
         {
            <MMSPageMediaWraper
               type={ type }
               onNextContent={ onNextContent }

            >

               {
                  !isFetching && list && list.map(media => {
                     return (
                        <MediaCard
                           key={ media.id }
                           media={ media }
                           href={ getMediaIndividualPagePath(getTheHref, media) }
                           { ...cardPropsProps }
                        />
                     )
                  })
               }
               {
                  (isFetching || isNextFetching) && (
                     <>
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                     </>
                  )
               }
            </MMSPageMediaWraper>
         }
      </div>
   );
}
ContentShowcase.propTypes = {
   settings: PropTypes.object,
   globalSettings: PropTypes.object,
   type: PropTypes.oneOf([
      'video', 'story', 'store', 'recorded_stream', 'photoset',
   ]),
   data: PropTypes.object,
   isMobile: PropTypes.bool,
   isFetching: PropTypes.bool,
   onNextContent: PropTypes.bool,
   isNextFetching: PropTypes.bool,
   isNextApp: PropTypes.bool,
   contentShowcaseRef: PropTypes.any,
   getTheHref: PropTypes.func,
   sitePages: PropTypes.array,
};

export default ContentShowcase;


